/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { ProfitMarginCreateUpdateDTOToJSON, ProfitMarginResponseDTOFromJSON, } from '../models/index';
/**
 *
 */
export class ProfitMarginControllerApi extends runtime.BaseAPI {
    /**
     */
    async getMarginsRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling getMargins().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/margins/{marketplace}`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProfitMarginResponseDTOFromJSON));
    }
    /**
     */
    async getMargins(requestParameters, initOverrides) {
        const response = await this.getMarginsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async seedDefaultForUserRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling seedDefaultForUser().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/margins/{marketplace}/seed-default`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async seedDefaultForUser(requestParameters, initOverrides) {
        await this.seedDefaultForUserRaw(requestParameters, initOverrides);
    }
    /**
     */
    async updateMarginsRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling updateMargins().');
        }
        if (requestParameters['profitMarginCreateUpdateDTO'] == null) {
            throw new runtime.RequiredError('profitMarginCreateUpdateDTO', 'Required parameter "profitMarginCreateUpdateDTO" was null or undefined when calling updateMargins().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/margins/{marketplace}`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['profitMarginCreateUpdateDTO'].map(ProfitMarginCreateUpdateDTOToJSON),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async updateMargins(requestParameters, initOverrides) {
        await this.updateMarginsRaw(requestParameters, initOverrides);
    }
}
/**
 * @export
 */
export const GetMarginsMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const SeedDefaultForUserMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const UpdateMarginsMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
